import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterSunsetbeach() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-sunsetbeach",
    name: "Painters Sunset Beach",
    location: "Sunset Beach, Cape Town",
    rating: 4.9,
    reviews: 178,
    specialties: ["Coastal Properties", "Beach Houses", "Marine-Grade Finishes", "Weather Protection"],
    image: "https://public.readdy.ai/ai/img_res/39a5c0bcf15790555d5a7b8934d42e9b.jpg",
    verified: true,
    yearsExperience: 17,
    website: "https://painterssunsetbeach.co.za",
    email: "info@painterssunsetbeach.co.za",
    description: "Professional painting services in Sunset Beach and surrounding coastal areas. We specialize in beach properties and coastal homes with expertise in marine-grade finishes and comprehensive weather protection solutions.",
    services: [
      "Coastal Property Painting",
      "Beach House Painting", 
      "Marine-Grade Coatings",
      "Weather Protection Systems",
      "Salt Damage Prevention",
      "Waterproofing Services",
      "Exterior Restoration",
      "Interior Coastal Design"
    ],
    serviceAreas: ["Sunset Beach", "Melkbosstrand", "Big Bay", "Bloubergstrand", "Table View", "West Beach", "Parklands", "Atlantic Seaboard"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Sunset%20Beach%2C%20coastal%20home%20with%20fresh%20white%20walls%2C%20quality%20paint%20finish%2C%20ocean%20view%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%2C%20beach%20house%20design&width=400&height=300&seq=sunsetbeach-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20beach%20house%20painting%20project%20in%20Sunset%20Beach%20Cape%20Town%2C%20coastal%20property%20with%20fresh%20marine-grade%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20ocean%20setting%2C%20well-maintained%20beachfront%20property&width=400&height=300&seq=sunsetbeach-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Coastal%20property%20painting%20project%20in%20Sunset%20Beach%2C%20professional%20painters%20working%20on%20beach%20house%20exterior%2C%20quality%20marine-grade%20paint%20finish%2C%20modern%20coastal%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=sunsetbeach-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Sunset%20Beach%20coastal%20home%2C%20fresh%20painted%20walls%2C%20modern%20beach%20house%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=sunsetbeach-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20interior%20painting%20in%20Sunset%20Beach%20beach%20house%2C%20fresh%20painted%20walls%2C%20elegant%20coastal%20bedroom%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work%2C%20ocean%20views&width=400&height=300&seq=sunsetbeach-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20facade%20painting%20in%20Sunset%20Beach%20beachfront%20property%2C%20professional%20painters%20working%20on%20coastal%20home%2C%20quality%20marine-grade%20finish%2C%20modern%20beach%20architecture%2C%20pristine%20coastal%20environment&width=400&height=300&seq=sunsetbeach-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Jennifer Thompson",
        rating: 5,
        comment: "Exceptional work on our Sunset Beach home. The team understood the coastal environment perfectly and used the right materials for salt air protection. Our beach house looks stunning and we're confident it's well protected."
      },
      {
        name: "Mark van der Merwe", 
        rating: 5,
        comment: "Outstanding service from start to finish. They completed our beachfront property painting with great attention to detail and the marine-grade finishes are holding up beautifully. Highly recommend for coastal properties."
      },
      {
        name: "Sarah Collins",
        rating: 5,
        comment: "Professional painters who truly understand coastal living. They were clean, efficient, and the quality of work exceeded our expectations. Our beach house has never looked better."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Sunset Beach | Professional Coastal Painting Services Cape Town | Beach House Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Sunset Beach offers professional painting services for coastal properties and beach houses in Sunset Beach, Cape Town. Specializing in marine-grade finishes, weather protection, and salt damage prevention. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Sunset Beach, beach house painters Cape Town, coastal property painting, marine-grade finishes, weather protection painting');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20beach%20house%20in%20Sunset%20Beach%20Cape%20Town%2C%20beautiful%20coastal%20property%20with%20Atlantic%20Ocean%20views%20and%20Table%20Mountain%20backdrop%2C%20painters%20in%20clean%20uniforms%20with%20premium%20equipment%2C%20modern%20beach%20architecture%20with%20large%20windows%2C%20bright%20natural%20lighting%2C%20high%20quality%20coastal%20residential%20painting%20project&width=1200&height=600&seq=sunsetbeach-painters-hero&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Sunset Beach</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Coastal Property Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Sunset Beach is one of Cape Town's most beautiful coastal areas, renowned for its stunning ocean views, pristine beaches, and relaxed lifestyle. Our team has over 17 years of specialized experience working in this unique coastal environment, understanding the specific challenges that salt air, wind, and moisture present to painted surfaces. We've built our reputation on delivering exceptional painting services that not only enhance the beauty of coastal properties but also provide superior protection against the harsh marine environment.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Living by the ocean is a dream for many, but it comes with unique maintenance challenges. The combination of salt spray, strong winds, intense UV radiation, and moisture creates an environment that can quickly deteriorate standard paint finishes. Our specialized approach to coastal painting uses marine-grade materials and proven techniques that have been developed and refined over nearly two decades of working exclusively in coastal areas. We understand that your beach property represents a significant investment, and proper protection is essential to maintaining its value and beauty for years to come.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Marine-Grade Materials and Advanced Protection</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Standard painting materials simply aren't adequate for coastal properties. The harsh marine environment requires specialized products that can withstand constant exposure to salt, moisture, and UV radiation. We exclusively use marine-grade paints and coatings that have been specifically formulated for coastal applications. These premium products contain advanced additives that provide superior adhesion, flexibility, and resistance to salt damage, ensuring your property maintains its beautiful appearance while being fully protected from environmental damage.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our marine-grade coating systems include specialized primers that create a strong bond with substrate surfaces and provide an effective barrier against moisture penetration. We use topcoats with enhanced UV resistance to prevent fading and chalking, and advanced formulations that resist mildew and algae growth in the humid coastal environment. These premium materials cost more than standard paints, but they provide significantly longer service life and better protection, making them a wise investment for coastal property owners who want to minimize maintenance costs and maximize property value.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Surface Preparation for Coastal Properties</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Proper surface preparation is absolutely critical for successful coastal painting projects. Salt deposits, existing corrosion, and weathered surfaces must be thoroughly addressed before new coatings can be applied. Our comprehensive preparation process includes pressure washing to remove salt buildup and contaminants, scraping and sanding to remove loose or failing paint, treatment of any rust or corrosion on metal surfaces, and repair of damaged substrates. We never cut corners on preparation because we know that the longevity of the paint system depends on proper surface preparation.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  For properties that have experienced salt damage or moisture penetration, we provide specialized restoration services to address underlying issues before painting. This may include wood replacement for rotted sections, rust treatment and priming for metal components, and application of specialized sealers to prevent future moisture problems. Our thorough approach ensures that we're not just covering up problems with fresh paint, but actually addressing the root causes and providing long-term solutions that protect your property investment.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Beach House Interior Design and Finishes</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Beach house interiors require a different approach than standard residential painting. The coastal lifestyle calls for finishes that are both beautiful and practical, able to withstand sandy feet, wet swimsuits, and the general wear and tear of beach living. We specialize in creating interior spaces that capture the relaxed, airy feel of coastal living while using durable, washable finishes that can handle the demands of beach house life. Our color consultation services help you choose palettes that enhance natural light, create a sense of space, and complement the stunning ocean views.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We use premium interior paints with enhanced washability and stain resistance, perfect for high-traffic areas and spaces that see frequent use. Our low-VOC formulations are safe for your family while providing excellent coverage and durability. We understand the importance of moisture control in coastal interiors and can recommend and apply specialized primers and paints that resist mildew growth in bathrooms, kitchens, and other humid areas. Our goal is to create beautiful interior spaces that are as practical as they are attractive, perfectly suited to the coastal lifestyle.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Weather Protection Systems</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Protecting your coastal property's exterior requires more than just paint – it requires a comprehensive weather protection system. Our exterior painting services include multiple layers of protection, starting with specialized primers that seal surfaces and prevent moisture penetration, followed by intermediate coats that build thickness and durability, and finishing with premium topcoats that provide color, gloss, and the final barrier against environmental damage. This multi-layer approach provides superior protection compared to single-coat systems and ensures your property is fully protected from the harsh coastal environment.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We pay special attention to areas most vulnerable to weather damage, including window and door frames, trim and fascia boards, deck and balcony surfaces, and any areas where water can collect or penetrate. These critical areas receive extra coats and specialized sealants to ensure complete protection. We also offer waterproofing services for walls, foundations, and other surfaces that are particularly vulnerable to moisture penetration. Our comprehensive approach ensures every part of your property's exterior is properly protected and will maintain its appearance and integrity for years to come.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Salt Damage Prevention and Restoration</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Salt damage is one of the most significant challenges facing coastal property owners. Salt spray carried by ocean winds can deposit on painted surfaces, where it attracts moisture and accelerates paint failure. Over time, salt can penetrate through paint films and cause corrosion of underlying substrates, particularly metal components. Our salt damage prevention services include regular maintenance programs that remove salt deposits before they can cause damage, application of specialized coatings that resist salt penetration, and comprehensive restoration services for properties that have already experienced salt-related damage.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-8">
                  For properties with existing salt damage, we provide thorough assessment and restoration services. This includes identifying all affected areas, removing damaged coatings and treating corroded substrates, applying specialized rust converters and primers to metal surfaces, and rebuilding the protective coating system with marine-grade materials. We also provide guidance on maintenance practices that will help prevent future salt damage, including recommended cleaning schedules and inspection procedures. Our goal is not just to fix current problems but to help you maintain your property in excellent condition for the long term.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20beautiful%20beach%20house%20in%20Sunset%20Beach%20Cape%20Town%2C%20stunning%20coastal%20property%20with%20ocean%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20modern%20beach%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=sunsetbeach-sidebar-image&orientation=landscape"
                      alt="Professional painters Sunset Beach coastal house painting services Cape Town beach properties"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Sunset Beach</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Specialized Coastal Painting Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for the unique requirements of Sunset Beach's coastal environment. From beach house interiors to comprehensive exterior protection systems, we provide specialized solutions that combine marine-grade materials with expert application techniques and meticulous attention to detail.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} services with marine-grade materials and expert coastal application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Coastal Design</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our interior painting services create beautiful beach house spaces that capture the essence of coastal living. We use premium paints with enhanced washability and moisture resistance, perfect for the demands of beach house life. Our color consultation services help you choose palettes that maximize natural light and complement ocean views.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the unique requirements of coastal interiors, including the need for mildew-resistant finishes in humid areas and durable, washable surfaces in high-traffic spaces. Our low-VOC formulations are safe for your family while providing excellent performance and longevity.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Marine-Grade Exterior Protection</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Sunset Beach requires specialized marine-grade materials and expert application techniques. We use premium coatings specifically formulated to withstand salt spray, UV radiation, and moisture. Our comprehensive exterior painting process includes thorough surface preparation, specialized primers, and multiple coats of marine-grade paint for maximum protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also offer specialized services including waterproofing, salt damage restoration, and weather protection systems. Our comprehensive approach ensures your coastal property is fully protected from environmental damage while maintaining beautiful appearance for years to come.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Sunset Beach</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Sunset Beach and surrounding coastal areas. Each project demonstrates our commitment to quality workmanship and our expertise in coastal property painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Sunset Beach Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional coastal painting with marine-grade materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Sunset Beach have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from coastal property owners in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Sunset Beach</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Sunset Beach property with professional coastal painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that protect your coastal investment.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding coastal areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Sunset Beach painting project. Our experienced team will assess your coastal property and provide detailed recommendations tailored to marine environment requirements.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
